import {FC} from "react";
import {ITypeRadar} from "../../types";
import {BtnBack, Container} from "./styles";
import IconBtnBack from "../../assets/icons/icon-btn-back.svg";
import SidebarInfoMapTehnology from "./MapTehnology";
import SidebarInfoFinTech from "./FinTech";
import SidebarInfoStateInitiative from "./StateInitiative";

interface IProps {
  typeRadar: ITypeRadar;
  isOpen?: boolean;
  close: (arg0: boolean) => void;
}

const SidebarInfo: FC<IProps> = ({typeRadar, close, isOpen = true}) => {
  const renderContent = () => {
    switch (typeRadar) {
      case "map":
        return <SidebarInfoMapTehnology />;
      case "fintech":
        return <SidebarInfoFinTech />;
      case "stateInitiative":
        return <SidebarInfoStateInitiative />;
      //   case "weakSignals":
      //     return <SideBarInfoWeakSignals />;
      default:
        return <SidebarInfoMapTehnology />;
    }
  };
  const renderTitle = () => {
    switch (typeRadar) {
      case "map":
        return "Методология Карты технологий";
      case "fintech":
        return "Методология FinTech";
      case "stateInitiative":
        return "Методология ЦРГЦИ";
      //   case "weakSignals":
      //     return "Слабые сигналы";
      default:
        return "Методология Карты технологий";
    }
  };
  return (
    <Container>
      <div
        style={{
          display: "flex",
          fontWeight: 700,
          fontSize: "16px",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px 30px 10px 30px",
          borderBottom: "1px solid #4E5574",
          position: "sticky",
          top: 0,
          zIndex: 1,
          backgroundColor: "#0c0d15",
        }}
      >
        {renderTitle()}
        <BtnBack onClick={() => close(false)}>
          <img src={IconBtnBack} alt="" />
        </BtnBack>
      </div>
      <div>{renderContent()}</div>
    </Container>
  );
};

export default SidebarInfo;
